import { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { submitContact, resetContact } from '../lib/actions/contactActions';

const SERVICES = [
  'Plomberie',
  'Chauffage',
  'Climatisation',
  'Salle de bain clé en main',
  'Pompe à chaleur',
  'Autre',
];

const EMPTY = { prenom: '', nom: '', email: '', telephone: '', service: '', message: '' };

const PhoneIcon = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 16.92v3a2 2 0 01-2.18 2 19.79 19.79 0 01-8.63-3.07A19.5 19.5 0 013.07 9.8a19.79 19.79 0 01-3.07-8.68A2 2 0 012 .82h3a2 2 0 012 1.72c.127.96.361 1.903.7 2.81a2 2 0 01-.45 2.11L6.91 8.77a16 16 0 006.29 6.29l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.573 2.81.7A2 2 0 0122 16.92z"/>
  </svg>
);

const MailIcon = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
    <polyline points="22,6 12,13 2,6"/>
  </svg>
);

const MapIcon = () => (
  <svg viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0118 0z"/>
    <circle cx="12" cy="10" r="3"/>
  </svg>
);

const ContactForm = () => {
  const dispatch = useDispatch();
  const { loading, success, error } = useSelector((state) => state.contact);
  const [form, setForm] = useState(EMPTY);

  const set = (field) => (e) => setForm((prev) => ({ ...prev, [field]: e.target.value }));

  useEffect(() => {
    if (success) {
      setForm(EMPTY);
      const t = setTimeout(() => dispatch(resetContact()), 6000);
      return () => clearTimeout(t);
    }
  }, [success, dispatch]);

  const handleSubmit = (e) => {
    e.preventDefault();
    dispatch(submitContact(form));
  };

  return (
    <section className="section" id="contact">
      <div className="section-inner">
        <div className="contact-layout">
          <div className="contact-info">
            <div className="section-tag" style={{ display: 'inline-block', marginBottom: 16 }}>
              Contact
            </div>
            <h2>Demande de devis</h2>
            <p>
              Vous avez un projet de rénovation ? Remplissez le formulaire et
              recevez votre devis directement par mail.
            </p>

            <div className="contact-details">
              <div className="contact-item">
                <div className="contact-icon"><MailIcon /></div>
                <div>
                  <div className="contact-item-label">Email</div>
                  <div className="contact-item-value">contact@tramenergie.com</div>
                </div>
              </div>
              <div className="contact-item">
                <div className="contact-icon"><MapIcon /></div>
                <div>
                  <div className="contact-item-label">Zone d'intervention</div>
                  <div className="contact-item-value">Loiret</div>
                </div>
              </div>
            </div>

          </div>

          <div className="form-card">
            <form onSubmit={handleSubmit} noValidate>
              {success && (
                <div className="form-alert success">
                  Votre demande a bien été envoyée ! Vous recevrez votre devis par mail sous 24 h.
                </div>
              )}
              {error && (
                <div className="form-alert error">{error}</div>
              )}

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Prénom *</label>
                  <input
                    className="form-input"
                    type="text"
                    value={form.prenom}
                    onChange={set('prenom')}
                    required
                    placeholder="Jean"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Nom *</label>
                  <input
                    className="form-input"
                    type="text"
                    value={form.nom}
                    onChange={set('nom')}
                    required
                    placeholder="Dupont"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label className="form-label">Email *</label>
                  <input
                    className="form-input"
                    type="email"
                    value={form.email}
                    onChange={set('email')}
                    required
                    placeholder="jean.dupont@email.fr"
                  />
                </div>
                <div className="form-group">
                  <label className="form-label">Téléphone</label>
                  <input
                    className="form-input"
                    type="tel"
                    value={form.telephone}
                    onChange={set('telephone')}
                    placeholder="06 XX XX XX XX"
                  />
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Service concerné *</label>
                <select
                  className="form-input"
                  value={form.service}
                  onChange={set('service')}
                  required
                >
                  <option value="">Sélectionner un service...</option>
                  {SERVICES.map((s) => (
                    <option key={s} value={s}>{s}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Description du projet *</label>
                <textarea
                  className="form-input"
                  value={form.message}
                  onChange={set('message')}
                  required
                  placeholder="Décrivez votre projet, les travaux souhaités, votre situation actuelle..."
                />
              </div>

              <button
                type="submit"
                className="btn btn-primary btn-full"
                disabled={loading}
              >
                {loading ? 'Envoi en cours...' : 'Envoyer ma demande'}
              </button>
            </form>
          </div>
        </div>

        <div className="contact-map">
          <iframe
            title="Zone d'intervention — Loiret"
            src="https://www.openstreetmap.org/export/embed.html?bbox=1.2%2C47.4%2C3.1%2C48.4&layer=mapnik&marker=47.9029%2C1.9039"
            style={{ border: 0, width: '100%', height: '100%' }}
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};

export default ContactForm;
